<template>
    <v-card class="pa-1 mb-0">
        <v-list class="px-1 py-0">
            <v-list-item-content class="pa-1 ma-0 body-2">
                <v-list-item-title class="title body-2">
                    {{index + 1}} {{getTitleMethodById(Object.keys(model)[0])}}
                </v-list-item-title>
                <v-list-item-action class="ma-0 mx-3">
                    <span class="grey--text title body-2">{{otherName}}</span>
                </v-list-item-action>
            </v-list-item-content>
        </v-list>
        <v-card-actions class="py-0">
            <v-container fluid class="py-0">
                <v-row>
                    <v-spacer/>
                    <v-col cols="3" class="pa-0 pa-0">
                        <v-btn small icon color="blue lighten-3" @click="$emit('editModel', index)"
                        >
                            <v-icon small>edit</v-icon>
                        </v-btn>
                        <v-btn small icon color="red lighten-2" @click="$emit('removeModel', index)"
                        >
                            <v-icon small>delete</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-actions>
    </v-card>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
    name: 'MessageCard',
    props: ['model', 'index', 'status'],
    methods: {
        editMailing() {
            this.$emit('editModel', this.index)
        },
        zero(number) {
            if (number < 10) {
                number = '0' + number
            }
            return number
        }
    },
    computed: {
        ...mapGetters({
            moduleGroups: 'moduleGroups/moduleGroups',
            modules: 'modules/modules',
            getTitleMethodById: 'modules/getTitleMethodById'
        }),
        otherName() {
            return this.model[Object.keys(this.model)[0]] != null && this.model[Object.keys(this.model)[0]].hasOwnProperty('other') ? this.model[Object.keys(this.model)[0]]['other'][0][1] : ''
        }
    }
}
</script>

<style scoped>

</style>
